import type { PaymentMethodType } from '../../entities/enums';

class PaymentSavedCreditCardPayError extends Error {
  paymentIntentId: string;
  paymentIntentStatus: string;
  errorCode?: string;
  declineCode?: string;
  param?: string;
  constructor(
    message: string,
    paymentIntentId: string,
    paymentIntentStatus: string,
    errorCode?: string,
    declineCode?: string,
    param?: string,
  ) {
    super(message);
    this.name = 'PaymentSavedCreditCardPayError';
    this.paymentIntentId = paymentIntentId;
    this.paymentIntentStatus = paymentIntentStatus;
    this.errorCode = errorCode;
    this.declineCode = declineCode;
    this.param = param;
  }
}

class PaymentCardUnsupportedError extends Error {
  declineCode: string;
  constructor(message: string) {
    super(message);
    this.name = 'PaymentCardUnsupportedError';
    this.declineCode = 'card_not_supported';
  }
}

class PaymentIntentExpire extends Error {
  declineCode: string;
  constructor(message: string) {
    super(message);
    this.name = 'PaymentIntentExpire';
    this.declineCode = 'payment_expired';
  }
}

class PaymentConfirmationError extends Error {
  errorType: string;
  errorCode?: string;
  declineCode?: string;
  constructor(
    message: string,
    errorType: string,
    errorCode?: string,
    declineCode?: string,
  ) {
    super(message);
    this.name = 'PaymentConfirmationError';
    this.errorType = errorType;
    this.errorCode = errorCode;
    this.declineCode = declineCode;
  }
}

type OrderErrorCode =
  | 'order_invalid'
  | 'order_expired'
  | 'order_not_found'
  | 'promocode_invalid';

class OrderError extends Error {
  errorCode?: OrderErrorCode;
  constructor(message: string, errorCode?: OrderErrorCode) {
    super(message);
    this.name = 'OrderError';
    this.errorCode = errorCode;
  }
}

class PaymentGeneralError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PaymentGeneralError';
  }
}

class CreditCardFormNotValidError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'CreditCardFormNotValidError';
  }
}

class PaymentActionRequiredError extends Error {
  paymentMethod: PaymentMethodType;
  userMessage?: string;
  constructor(
    message: string,
    paymentMethod: PaymentMethodType,
    userMessage?: string,
  ) {
    super(message);
    this.name = 'PaymentActionRequiredError';
    this.paymentMethod = paymentMethod;
    this.userMessage = userMessage;
  }
}

class PaymentDefaultError extends Error {
  /**
   * Internal message for debugging
   */
  internalMessage: string;
  constructor(internalMessage: string) {
    super();
    this.internalMessage = internalMessage;
    this.name = 'PaymentDefaultError';
    this.message = 'order.error.payment.error';
  }
}

const mapOrderPayloadTypeToErrorCode: Record<string, OrderErrorCode> = {
  OrderExpiredError: 'order_expired',
  OrderNotFoundError: 'order_not_found',
  OrderInvalidError: 'order_invalid',
  PromotionInvalidError: 'promocode_invalid',
};

export {
  PaymentSavedCreditCardPayError,
  PaymentConfirmationError,
  PaymentCardUnsupportedError,
  PaymentIntentExpire,
  PaymentGeneralError,
  OrderError,
  type OrderErrorCode,
  CreditCardFormNotValidError,
  PaymentActionRequiredError,
  PaymentDefaultError,
  mapOrderPayloadTypeToErrorCode,
};
